import React from "react";
import "../../App.css";
import NavbarComp from "../navbar/navbar";

class NotFound extends React.Component {
  render() {
    return (
      <div className="container d-flex justify-content-center mt-5">
        <div className="centered-box w-lg-75 w-100">
          <NavbarComp />

          <div className="not-found-page">
            <p className="home-kicker">
              <span>404</span>
              <span>Page not found</span>
            </p>

            <p className="home-intro not-found-intro">
              The page you are looking for does not exist or may have moved.
            </p>

            <div className="home-actions not-found-actions">
              <a className="home-primary-link" href="/">
                Go home
              </a>
              <a className="home-secondary-link" href="/contact">
                Contact
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NotFound;
